import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Logout from "../features/authentication/Logout.jsx";
import {useUser} from "../hooks/useUser.js";
import Button from "./Button.jsx";


const DropdownMenu = () => {
    const [open, setOpen] = useState(false);

    // Load the authenticated user
    const { user, isAuthenticated } = useUser();

    const handleClick = () => {
        setOpen((prev) => !prev); // Toggle menu state
    };

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (!event.target.closest('.menu') && !event.target.closest('.icon-button')) {
                handleClose();
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    return (
        <div className="relative">
            <Button
                size="small"
                className="w-10 h-10 !p-0 aspect-square flex items-center justify-center rounded-full 
                shadow-lg !bg-black hover:!bg-black transition"
                onClick={handleClick}
                aria-label="menu"
            >
                <img
                    src="/Menu-icon.png"
                    alt="menu icon"
                />
            </Button>


            {/* Dropdown Menu */}
            {open && (
                <div
                    className="menu absolute top-full right-0 mt-2 w-48 bg-white shadow-lg rounded-lg border border-gray-200">
                    <ul className="py-2 space-y-2 text-gray-700">

                        {/* Home Route with Link */}
                        <li>
                            <Link to="/"
                                  className="flex items-center gap-3 px-4 py-2 hover:bg-pink-100 w-full !text-gray-700"
                                  onClick={handleClose}>
                                {/*<FiCalendar className="text-pink-500 text-lg"/> Calendar*/}
                                <div className="text-pink-500 text-lg"/> Parties Calendar
                            </Link>
                        </li>

                        {/*{!isAuthenticated &&*/}
                        {/*    <li>*/}
                        {/*        <Link to="/login"*/}
                        {/*              className="flex items-center gap-3 px-4 py-2 hover:bg-pink-100 w-full !text-gray-700"*/}
                        {/*              onClick={handleClose}>*/}
                        {/*            /!*<FiLogIn className="text-pink-500 text-lg"/> Login*!/*/}
                        {/*            <div className="text-pink-500 text-lg"/> Login*/}
                        {/*        </Link>*/}
                        {/*    </li>*/}
                        {/*}*/}

                        <li>
                            <Link to="/queer-retail"
                                  className="flex items-center gap-3 px-4 py-2 hover:bg-pink-100 w-full !text-gray-700"
                                  onClick={handleClose}>
                                {/*<FiShoppingBag className="text-pink-500 text-lg"/> Queer Retail*/}
                                <div className="text-pink-500 text-lg"/> Queer Retail
                            </Link>
                        </li>

                        <li>
                            <Link to="/health-and-safety"
                                  className="flex items-center gap-3 px-4 py-2 hover:bg-pink-100 w-full !text-gray-700"
                                  onClick={handleClose}>
                                {/*<FiHeart className="text-pink-500 text-lg"/> Health & Safety*/}
                                <div className="text-pink-500 text-lg"/> Health & Safety
                            </Link>
                        </li>
                        
                        <li>
                            <Link to="/roadmap"
                                  className="flex items-center gap-3 px-4 py-2 hover:bg-pink-100 w-full !text-gray-700"
                                  onClick={handleClose}>
                                {/*<FiMail className="text-pink-500 text-lg"/> Contact Us*/}
                                <div className="text-pink-500 text-lg"/> Roadmap
                            </Link>
                        </li>

                        <li>
                            <Link to="/contact-us"
                                  className="flex items-center gap-3 px-4 py-2 hover:bg-pink-100 w-full !text-gray-700"
                                  onClick={handleClose}>
                                {/*<FiMail className="text-pink-500 text-lg"/> Contact Us*/}
                                <div className="text-pink-500 text-lg"/> Contact Us
                            </Link>
                        </li>
                        
                        {/* Admin Route with Link */}
                        {isAuthenticated && user.role === 'admin' &&
                            <li>
                                <Link to="/admin"
                                      className="flex items-center gap-3 px-4 py-2 hover:bg-pink-100 w-full !text-gray-700"
                                      onClick={handleClose}>
                                    {/*<FiCode className="text-pink-500 text-lg "/> Admin*/}
                                    <div className="text-pink-500 text-lg "/> Admin
                                </Link>
                            </li>
                        }

                        {isAuthenticated &&
                            <li>
                                <Logout/>
                            </li>
                        }
                    </ul>
                </div>
            )}
        </div>
    );
};

export default DropdownMenu;
